import { useEffect } from "react";
import { TbLoader2 } from "react-icons/tb";
import { Link, useParams } from "react-router-dom";
import { LinkGen } from "../LinkGen";
import { useAuth } from "./useAuth";

export const PageAuthConsume = () => {
  const { id, secret } = useParams();
  const {
    consumeSession: { mutate, error },
  } = useAuth();

  useEffect(() => {
    mutate({
      id: Number(id),
      secret: secret ?? "",
    });
  }, [id, secret, mutate]);

  return (
    <div>
      {error ? (
        <>
          <div>There was a problem logging you in.</div>
          <p>Please try again using the link below</p>
          <Link to={LinkGen.Auth()}>Email me a new link</Link>
        </>
      ) : (
        <>
          <div>
            <TbLoader2 className="icon-spin" /> You are being logged in..
          </div>
          <span>
            Please wait while we authenticate you. If you dont automatically get
            redirected, please click the button below.
          </span>
        </>
      )}
    </div>
  );
};
